export default {
    BASE_URL: '/index',
    api: [
        {
            name: 'summary',
            desc: '获取头部项目汇总信息',
            method: 'GET',
            path: '/findProjectSummary'
        },
        {
            name: 'projWorker',
            desc: '项目出勤统计',
            method: 'GET',
            path: '/findAttendanceSummary'
        },
        {
            name: 'recordAmounts',
            desc: '记工费用统计',
            method: 'GET',
            path: '/findWorkDataSummary'
        },
        {
            name: 'monthTeamProjWorker',
            desc: '本月各班组出勤人数',
            method: 'GET',
            path: '/findTeamAttendPersonalCnt'
        },
        {
            name: 'monthTeamRecordAmounts',
            desc: '本月各班组记工费用',
            method: 'GET',
            path: '/findTeamCost'
        },
        {
            name: 'projList',
            desc: '项目列表',
            method: 'GET',
            path: '/findProjectList'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/dashboard/member.js